import { Stack, Typography } from "@mui/material";
import { PlanningResourceLocationInfos } from "../../../Core/Api/Types/planning-resource-location-infos";
import { useTranslation } from "react-i18next";

export interface TableCellResourceLocationProps {
  location: PlanningResourceLocationInfos;
}

const TableCellResourceLocation: React.FC<TableCellResourceLocationProps> = ({ location }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={1.5}>
      <Stack flex={1} overflow="hidden">
        <Typography fontWeight={500} sx={(theme) => ({ ...theme.helpers(theme).ellipsis })}>
          {t("table:body.addressWithBuildingAndFloor", { building: location.building, floor: location.floor })}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TableCellResourceLocation;
